import useController from "@hooks/useController"

export default function useSalonNotificationController(salonId: string | number): Admin.Controllers.SalonNotification {
    const controller = useController(`/api/admin/salons/${salonId}/notifications`)

    const closing = () => controller.post('closing')
    const results = () => controller.post('results')
    const ebook = () => controller.post('ebook')
    const tracking = () => controller.post('tracking')
    const started = () => controller.post('started')

    return { ebook, closing, started, results, tracking }
}